<template>
    <section class="section__mapa section__mapa-bg" :class="{active: isMobile && isAnAreaSelected}">
      <div class="section__mapa--selected--area mobile"  :class="{'over-area': overAreaTitle && !isAnAreaSelected, 'selected-area': isAnAreaSelected && isMobile}">
        <div class="area__title">
          <div class="underlined">
            <div class="close  l-fabrica" @click="closeArea()">
              <font-awesome-icon :icon="['far', 'times-circle']" class="icon  l-fabrica"/>
            </div>
            <p class="title  l-fabrica">{{overAreaTitle}}</p>
            <div class="controllers  l-fabrica">
              <font-awesome-icon :icon="['far', 'angle-left']" class="icon l-fabrica"  @click="prevArea"/>
              <font-awesome-icon :icon="['far', 'angle-right']" class="icon l-fabrica"  @click="nextArea"/>
            </div>
          </div>
        </div>
      </div>
      <div class="screen" style="margin:0 auto;">
        <h1 class="section__mapa-title" v-if="!isAnAreaSelected">CENTRAL DE IDEAS <span v-if="overAreaTitle">> </span> <span class="light--blue">{{overAreaTitle}}</span></h1>
        <div class="section__mapa--screen l-fabrica" :class="{selected: isAnAreaSelected, 'absent': isMobile && !isAnAreaSelected}">
          <div class="section__mapa--selected--area l-fabrica" v-if="!isMobile && isAnAreaSelected">
            <div class="area__description l-fabrica">
              <p class="title l-fabrica" style="font-size: 2rem; font-weight: 600;">{{overAreaTitle}}</p>
              <p class="header l-fabrica" style="font-size: 16px; font-weight: 500;">{{selectedArea.header}}</p>
              <p class="paragraph l-fabrica" style="font-size: 14px; font-weight: 400;">{{selectedArea.description}}</p>
            </div>
            <div class="area__title l-fabrica">
              <div class="underlined l-fabrica">
                <div class="back l-fabrica" @click="closeArea()">
                  <font-awesome-icon :icon="['far', 'angle-left']" class="icon l-fabrica"/>
                  <p class="l-fabrica" style="font-size: 12px;">VOLVER</p>
                </div>
                <div class="controllers l-fabrica">
                  <font-awesome-icon :icon="['far', 'angle-left']" class="icon l-fabrica"  @click="prevArea"/>
                  <font-awesome-icon :icon="['far', 'angle-right']" class="icon l-fabrica"  @click="nextArea"/>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!isAnAreaSelected" class="section__mapa--active--areas l-fabrica">
            <svg class="cosito l-fabrica" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 2043.8 920.9" style="enable-background:new 0 0 2043.8 920.9;" xml:space="preserve">
              <polygon @click="select($store.state.areas[0])" @mouseenter="enterArea($store.state.areas[0])" @mouseleave="leaveArea" class="l-fabrica cuentas st39" points="791.1,460.4 954,370.6 954.3,319.7 1000.4,295.4 1000.4,163.4 530.5,26 337.5,131.6
                337.7,259 505.2,308.5 505.2,360.4 531.5,384.6"/>
              <polygon @mouseenter="enterArea($store.state.areas[6])" @mouseleave="leaveArea" class="l-fabrica hall st40" points="337.7,259 337.5,131.6 -0.3,315.7 -0.3,486.9 225.2,554.7 225.2,526.6 271.3,500.5
                271,448 373.4,381.8 373.4,445.4 437.7,411.1 437.7,388.9 448.6,382.7 459.6,385.4 505.2,361.4 505.2,308.5"/>
              <g @click="select($store.state.areas[1])" @mouseenter="enterArea($store.state.areas[1])" @mouseleave="leaveArea" class="l-fabrica creatividad">
                <path class="l-fabrica st39" d="M271,448l-0.1,52.5l-46.1,26.1v28l427,128.7l-0.5-27.5l66.4-36.1v-31.2L814,538l-26.3-4.9v-51.9l-268.7-78.6
                  c0,0-0.5-35.7-34.5-24.2c0,0-6.1,2.3-10.4,11.1l-25.9-6.8l-10.9,6.2v22.2l-63.8,34.4v-63.7L271,448z"/>
              </g>
              <polygon @click="select($store.state.areas[4])" @mouseenter="enterArea($store.state.areas[4])" @mouseleave="leaveArea" class="l-fabrica redes st40" points="951.2,773.5 950.7,745.9 1087.9,672.9 1087.9,606 1154.6,573.2 1042,541.1
                1040.7,576.2 985.9,558.9 985.2,523.2 937.9,509.6 922.3,550.6 871.7,545.9 860.3,542 833.4,554.5 833.4,527.2 718.1,588.6
                718.1,619.8 651.7,655.9 652.2,683.4"/>
              <polygon @mouseenter="enterArea($store.state.areas[7])" @mouseleave="leaveArea" class="l-fabrica bathroom st39" points="1084.7,813.7 1084.7,786 1129.9,761.5 1130.9,693.6 1207.7,652.7 1207.8,715.4
                1319.7,658.9 1280.5,647.4 1279.6,582.3 1228.4,564.8 1216.8,568.3 1216.8,627.3 1167.8,611.8 1166.8,566.9 1087.9,606
                1087.9,672.9 950.7,745.9 951.2,773.5"/>
              <polygon @click="select($store.state.areas[5])" @mouseenter="enterArea($store.state.areas[5])" @mouseleave="leaveArea" class="l-fabrica it st40" points="1440.2,920.9 1084.7,813.7 1084.7,786 1129.9,761.5 1130.9,693.6 1207.7,652.7
                1207.8,715.4 1319.7,658.9 1377.7,631.9 1519.6,671.7 1518.3,644.4 1611.4,671.7 1611.4,699.2 1729.8,735.6 1729.8,762.8"/>
              <polygon @mouseenter="enterArea($store.state.areas[8])" @mouseleave="leaveArea" class="l-fabrica cocina st41" points="1788.8,573.4 1788.8,544.1 1765.2,536.5 1764.8,483.6 1715.3,468.6 1687.3,483.9
                1687.3,510.3 1587.8,480.6 1588.9,403.3 1536.9,386.4 1524.2,392.2 1524,464.2 1490.7,454.8 1261.8,576.2 1279.6,582.3
                1279.9,607.3 1519.6,671.7 1518.3,644.4 1611.4,671.7"/>
              <polygon @click="select($store.state.areas[2])" @mouseenter="enterArea($store.state.areas[2])" @mouseleave="leaveArea" class="l-fabrica design st40" points="866.7,482.5 867.6,453.3 920.5,422 922.3,411 953,392.9 954.3,319.7 1031.2,279.6
                1032.4,361.9 1087.6,333 1283,390.2 1289.9,361.6 1332.8,374.9 1326.8,404.3 1397.9,421.5 1399.5,407.7 1444.6,430 1444.6,437.8
                1490.7,454.8 1261.8,576.2 1228.4,564.8 1216.8,568.3 1216.8,588.3 1166.9,572.9 1166.8,566.9 1160.5,569.9"/>
              <polygon @mouseenter="enterArea($store.state.areas[9])" @mouseleave="leaveArea" class="l-fabrica patio st39" points="2043.7,403.9 1929,370.1 1928.3,354 1686.8,266.1 1521.5,350.9 1518.6,283.5
                1507.5,278.3 1460,306.3 1459.8,387 1408.1,411.9 1444.6,430 1444.6,437.8 1524,464.2 1524.2,392.2 1536.9,386.4 1588.9,403.3
                1587.8,480.6 1687.3,510.3 1687.3,483.9 1715.3,468.6 1764.8,483.6 1765.2,536.5 1788.8,544.1"/>
              <polygon @click="select($store.state.areas[3])" @mouseenter="enterArea($store.state.areas[3])" @mouseleave="leaveArea" class="l-fabrica audiovisual st41" points="1700.6,270.2 1700.6,121.2 1302.6,0 1000.4,163.4 1000.4,295.4 1031.2,279.6
                1032.4,361.9 1087.6,333 1283,390.2 1289.9,361.6 1332.8,374.9 1326.8,404.3 1397.9,421.5 1399.5,407.7 1408.1,411.9 1459.8,387
                1460,306.3 1507.5,278.3 1518.6,283.5 1521.5,350.9 1686.8,266.1"/>
              <g id="pasillo" @mouseenter="enterArea('PASILLO')" @mouseleave="leaveArea">
                <polygon class="l-fabrica st42" points="1319.7,658.9 1280.5,647.4 1279.9,607.3 1377.7,631.9"/>
                <polygon class="l-fabrica st42" points="1216.8,627.3 1216.8,588.3 1166.9,572.9 1167.8,611.8"/>
                <path class="l-fabrica st42" d="M1160.5,569.9l-6,3.3L1042,541.1l-1.3,35.1l-54.8-17.3l-0.7-35.7l-47.3-13.6l-15.6,41l-50.6-4.7l-11.4-3.9
                  l-26.9,12.5v-27.3l-19,10.8l-26.3-4.9v-51.9l-268.7-78.6c0,0,0-35.7-34.5-24.2c0,0-7,1.7-10.4,11.1l-14.9-4.1l45.6-25l26.3,24.2
                  l259.6,75.8L954,370.6l-1,22.3L922.3,411l-1.8,11l-52.9,31.3l-0.9,29.2L1160.5,569.9z"/>
              </g>
            </svg>
          </div>
          <div class="content section__mapa--animations l-fabrica" :style="selected" :class="{invisible: transitioning}">
            <div class="animation l-fabrica" id="cuentas"></div>
            <div class="animation l-fabrica" id="creatividad"></div>
            <div class="animation l-fabrica" id="design"></div>
            <div class="animation l-fabrica" id="audiovisual"></div>
            <div class="animation l-fabrica" id="redes"></div>
            <div class="animation l-fabrica" id="it"></div>
            <div class="animation l-fabrica" id="hall"></div>
            <div class="animation l-fabrica" id="bathroom"></div>
            <div class="animation l-fabrica" id="cocina"></div>
            <div class="animation l-fabrica" id="patio"></div>
            <img class="img l-fabrica" src="/img/png/Cuentas.png" id="cuentas__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'CUENTAS', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'CUENTAS'}" >
            <img class="img l-fabrica" src="/img/png/Creatividad.png" id="creatividad__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'CREATIVIDAD', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'CREATIVIDAD'}">
            <img class="img l-fabrica" src="/img/png/Design.png" id="design__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'DISEÑO', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'DISEÑO'}">
            <img class="img l-fabrica" src="/img/png/Audiovisual.png" id="audiovisual__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'AUDIOVISUAL', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'AUDIOVISUAL'}">
            <img class="img l-fabrica" src="/img/png/Redes.png" id="redes__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'REDES', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'REDES'}">
            <img class="img l-fabrica" src="/img/png/IT.png" id="it__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'I.T.', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'I.T.'}">
            <img class="img l-fabrica" src="/img/png/Hall.png" id="hall__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'HALL', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'HALL'}">
            <img class="img l-fabrica" src="/img/png/Bathroom.png" id="bathroom__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'BATHROOM', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'BATHROOM'}">
            <img class="img l-fabrica" src="/img/png/Cocina.png" id="cocina__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'COCINA', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'COCINA'}">
            <img class="img l-fabrica" src="/img/png/Patio.png" id="patio__img" style="pointer-events: none" :class="{off: !clear && overAreaTitle !== 'PATIO', 'semi-invisible': isAnAreaSelected && overAreaTitle !== 'PATIO'}">
            <img src="/img/png/Pasillo.png" id="pasillo__img" class="l-fabrica" :class="{off: !clear}">
          </div>
        </div>
      </div>
      <div class="section__mapa--areas--mobile l-fabrica"  v-if="isMobile && !isAnAreaSelected">
        <div class="button" @click="openAreaMobile($store.state.areas[0])" :style="bgImg('/img/png/Cuentas_Icon.png')">
          <div class="content">
            <p class="button__title">Cuentas</p>
          </div>
        </div>
        <div class="button" @click="openAreaMobile($store.state.areas[1])" :style="bgImg('/img/png/Creatividad_Icon.png')">
          <div class="content">
            <p class="button__title">Creatividad</p>
          </div>
        </div>
        <div class="button" @click="openAreaMobile($store.state.areas[2])" :style="bgImg('/img/png/DG_Icon.png')">
          <div class="content">
            <p class="button__title">Diseño</p>
          </div>
        </div>
        <div class="button" @click="openAreaMobile($store.state.areas[3])" :style="bgImg('/img/png/Audiovisual_Icon.png')">
          <div class="content">
            <p class="button__title">Audiovisual</p>
          </div>
        </div>
        <div class="button" @click="openAreaMobile($store.state.areas[4])" :style="bgImg('/img/png/Redes_Icon.png')">
          <div class="content">
            <p class="button__title">Redes</p>
          </div>
        </div>
        <div class="button" @click="openAreaMobile($store.state.areas[5])" :style="bgImg('/img/png/IT_Icon.png')">
          <div class="content">
            <p class="button__title">IT</p>
          </div>
        </div>
      </div>
      <div class="section__mapa--selected--area mobile l-fabrica"  :class="{'over-area': overAreaTitle && !isAnAreaSelected, 'selected-area': isAnAreaSelected && isMobile}">
        <div class="area__description l-fabrica"  :class="{'fadeOutLeft' : fadeLeft, 'fadeOutRight' : fadeRight}">
          <p class="header avant-demi l-fabrica" style="font-weight: 600;">{{selectedArea.header}}</p>
          <p class="paragraph avant-book l-fabrica">{{selectedArea.description}}</p>
        </div>
      </div>
    </section>
</template>
<script>
import Hammerjs from 'hammerjs'
import Lottie from './../../node_modules/lottie-web/build/player/lottie'
import mixins from '@/mixins/mixins.js'

export default {
  data () {
    return {
      clear: true,
      overAreaTitle: undefined,
      isAnAreaSelected: false,
      viewportWidth: 0,
      transitioning: false,
      count: 0,
      fadeLeft: false,
      fadeRight: false,
      alreadyClicked: false,
      loaded: false
    }
  },
  created () {
    this.viewportWidth = window.innerWidth
    window.addEventListener('resize', () => {
      this.viewportWidth = window.innerWidth
    })
  },
  mounted () {
    const hammer = new Hammerjs(this.$el)
    hammer.domEvents = true
    hammer.on('tap', (ev) => {
      if (
        !ev.target.classList.value.includes('l-fabrica')
        && this.isAnAreaSelected
      ) {
        this.closeArea()
      }
    })
    this.$store.commit('setScrolling', false)
    this.$store.commit('setAreaAnimationData', [0, {
      container: document.getElementById('cuentas'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/CUENTAS.json'
    }])
    this.$store.commit('setAreaAnimationData', [1, {
      container: document.getElementById('creatividad'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/CREATIVIDAD.json'
    }])
    this.$store.commit('setAreaAnimationData', [2, {
      container: document.getElementById('design'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/DG.json'
    }])
    this.$store.commit('setAreaAnimationData', [3, {
      container: document.getElementById('audiovisual'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/AUDIOVISUAL.json'
    }])
    this.$store.commit('setAreaAnimationData', [4, {
      container: document.getElementById('redes'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/REDES.json'
    }])
    this.$store.commit('setAreaAnimationData', [5, {
      container: document.getElementById('it'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/IT.json'
    }])
    this.$store.commit('setAreaAnimationData', [6, {
      container: document.getElementById('hall'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/HALL.json'
    }])
    this.$store.commit('setAreaAnimationData', [7, {
      container: document.getElementById('bathroom'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/BATHROOM.json'
    }])
    this.$store.commit('setAreaAnimationData', [8, {
      container: document.getElementById('cocina'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/COCINA.json'
    }])
    this.$store.commit('setAreaAnimationData', [9, {
      container: document.getElementById('patio'),
      renderer: 'svg',
      loop: true,
      autoplay: true,
      path: '/data/PATIO.json'
    }])
    this.loaded = true
  },
  methods: {
    enterArea (anim) {
      // debugger;
      if (anim !== 'PASILLO' && !this.alreadyClicked) {
        this.clear = false
        this.overAreaTitle = anim.name
        Lottie.loadAnimation(anim.animation.data)
      } this.clear = false
    },
    leaveArea () {
      if (!this.alreadyClicked) {
        this.clear = true
        this.overAreaTitle = undefined
        Lottie.destroy()
      }
    },
    select (area, context = null) {
      if (!context) {
        this.alreadyClicked = true
      };
      this.transitioning = true
      setTimeout(() => {
        this.$store.commit('setSelectedArea', area)
        this.isAnAreaSelected = true
        this.count = area.id
        this.transitioning = false
      }, 300)
    },
    nextArea () {
      this.transitioning = true
      if (this.isMobile) {
        this.fadeLeft = true
      }
      setTimeout(() => {
        if (this.count < 5) {
          this.$store.commit('setSelectedArea', this.$store.state.areas[this.count + 1])
          this.count++
        } else {
          this.$store.commit('setSelectedArea', this.$store.state.areas[0])
          this.count = 0
        }
        this.overAreaTitle = this.selectedArea.name
        Lottie.destroy()
        Lottie.loadAnimation(this.selectedArea.animation.data)
        this.transitioning = false
        if (this.fadeLeft) {
          this.fadeLeft = false
        }
      }, 300)
    },
    prevArea () {
      this.transitioning = true
      if (this.isMobile) {
        this.fadeRight = true
      }
      setTimeout(() => {
        if (this.count > 0) {
          this.$store.commit('setSelectedArea', this.$store.state.areas[this.count - 1])
          this.count--
        } else {
          this.$store.commit('setSelectedArea', this.$store.state.areas[5])
          this.count = 5
        }
        this.overAreaTitle = this.selectedArea.name
        Lottie.destroy()
        Lottie.loadAnimation(this.selectedArea.animation.data)
        this.transitioning = false
        if (this.fadeRight) {
          this.fadeRight = false
        }
      }, 300)
    },
    closeArea () {
      this.transitioning = true
      setTimeout(() => {
        this.$store.commit('setSelectedArea', undefined)
        this.isAnAreaSelected = false
        Lottie.destroy()
        this.clear = true
        this.overAreaTitle = undefined
        this.transitioning = false
      }, 300)
      this.alreadyClicked = false
    },
    openAreaMobile (area) {
      this.select(area, 'mobile')
      this.enterArea(area)
      Lottie.loadAnimation(area.animation.data)
      document.querySelector('.section__mapa').scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  },
  computed: {
    isMobile () {
      if (this.viewportWidth <= 768) {
        return true
      } return false
    },
    closeMap () {
      return this.$store.state.closeMap
    },
    selected () {
      if (this.isAnAreaSelected) {
        return `
          pointer-events: none;
          transform: scale(${this.coordinates.zoom}, ${this.coordinates.zoom}) translate(${this.coordinates.x}, ${this.coordinates.y});
          -webkit-transform: scale(${this.coordinates.zoom}, ${this.coordinates.zoom}) translate(${this.coordinates.x}, ${this.coordinates.y});
          -ms-transform: scale(${this.coordinates.zoom}, ${this.coordinates.zoom}) translate(${this.coordinates.x}, ${this.coordinates.y});
        `
      } return ''
    },
    selectedArea () {
      if (!this.$store.state.selectedArea) {
        return {
          header: '',
          description: ''
        }
      } return this.$store.state.selectedArea
    },
    coordinates () {
      if (this.isAnAreaSelected) {
        if (this.isMobile) {
          return this.$store.state.selectedArea.mobileCoordinates
        } return this.$store.state.selectedArea.coordinates
      } return ''
    }
  },
  mixins: [
    mixins
  ],
  watch: {
    // whenever question changes, this function will run
    closeMap: function () {
      this.closeArea()
    }
  }
}
</script>
